<app-header-landing></app-header-landing>
<div id="main">
  <div class="section" id="section">
    <div id="not-allowed">
      <div class="title-container">
        <h2>{{'not_allowed.title'|translate}}</h2>
      </div>

      <div class="image-container">
        <mat-icon svgIcon="not-allowed"></mat-icon>
      </div>

      <div style="text-align: center; margin-top: 20px;">
        <h2>{{'not_allowed.access_denied'|translate}}</h2>
        <p>{{'not_allowed.user_not_allowed'|translate}}</p>
      </div>
    </div>
  </div>
</div>